import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditSalaryPay() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/SalaryPayLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Salary Pay"
      alert="Salary Pay Edited Successfully"
      editDataAPIEndPoint={`/SalaryPayFrequency/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/SalaryPayFrequency/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Salary Pay Type",
              name: "SPFL_Name",
              required: true, // Validation rule added here
              maxLength: 255,
            },
            {
              type: "select",
              label: "Status",
              name: "SPFL_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value: "1" },
                { label: "Inactive", value: "2" },
              ],
            },
          ],
        },
      ]}
      validationRules={{
        SPFL_Name: {
          required: true,
        },
        SPFL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditSalaryPay;
